import { i18n } from '@lingui/core';

export const locales = {
  en: 'English',
  es: 'Español',
  fr: 'Français',
  pt: 'Português',
};
export const defaultLocale = 'en';

const catalogLoaders = import.meta.glob<{ messages: Record<string, string> }>(
  '../locales/*/messages.ts'
);

/**
 * We do a dynamic import of just the catalog that we need
 * @param locale any locale string
 */
export async function dynamicActivate(locale: string) {
  const localeToLoad = locale in locales ? locale : defaultLocale;
  const loader = catalogLoaders[`../locales/${localeToLoad}/messages.ts`];

  if (!loader) {
    throw new Error(`Locale catalog not found for "${localeToLoad}"`);
  }

  const data = await loader();
  const messages = data?.messages || data;
  i18n.load(localeToLoad, messages);
  i18n.activate(localeToLoad);
}
